// extracted by mini-css-extract-plugin
export default {"container":"promotion-banner_container__hkI+r","small_view":"promotion-banner_small_view__5ndud"};